<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <!-- mini statistic start -->
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="mdi-bitcoin"
            :title="dashboardData.total_btc | numeral('0,0.00')"
            sub-title="BTC"
            color="orange"
          >
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="usdt"
            :title="
              (dashboardData.total_usdt - dashboardData.total_withdrawl_usdt)
                | numeral('0,0')
            "
            sub-title="USDT"
            color="light-blue"
          >
          </mini-statistic>
        </v-flex>
        <!-- <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="icon-XLM"
            :title="dashboardData.total_xlm | numeral('0,0')"
            sub-title="XLM"
            color="deep-purple accent-2"
          >
          </mini-statistic>
        </v-flex> -->
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="mdi-receipt"
            :title="dashboardData.total | numeral('0,0')"
            sub-title="Orders"
            color="green"
          >
          </mini-statistic>
        </v-flex>

        <v-flex lg12 sm12 xs12 v-if="dashboardData.report">
          <v-widget title="Number of orders" content-bg="white">
            <v-btn icon slot="widget-header-action" @click="getData">
              <v-icon class="text--secondary">refresh</v-icon>
            </v-btn>
            <div slot="widget-content">
              <e-chart
                :path-option="[
                  ['dataset.source', dashboardData.report],
                  ['color', [color.lightBlue.base, color.green.lighten1]],
                  ['legend.show', true],
                  ['xAxis.axisLabel.show', true],
                  ['yAxis.axisLabel.show', true],
                  ['grid.left', '2%'],
                  ['grid.bottom', '5%'],
                  ['grid.right', '3%'],
                  ['series[0].type', 'bar'],
                  ['series[0].areaStyle', {}],
                  ['series[0].smooth', true],
                  ['series[0].name', 'Total orders'],
                  ['series[1].smooth', true],
                  ['series[1].type', 'bar'],
                  ['series[1].areaStyle', {}],
                  ['series[1].name', 'Paid orders']
                ]"
                height="400px"
                width="100%"
              >
              </e-chart>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import EChart from "@/components/chart/echart";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import { mapGetters } from "vuex";

export default {
  components: {
    VWidget,
    MiniStatistic,
    EChart
  },
  data: () => ({
    color: Material,
    selectedTab: "tab-1"
  }),
  computed: {
    ...mapGetters(["dashboardData", "selectedApp"])
  },
  mounted() {
    this.getData();
    let self = this;
    this.$root.$on("SELECTED_APP_IS_CHANGED", () => {
      self.getData();
    });
  },
  methods: {
    getData() {
      this.$store
        .dispatch("getDashboardData", { app: this.selectedApp })
        .then(() => {})
        .catch(() => {});
    }
  }
};
</script>
